<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    장비정보-->
    <table-equipment
      class="mt-5"
      :list="form.equipmentList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    ></table-equipment>

    <!--    점검대상-->
    <!--    <vs-row class="mt-6">-->
    <!--      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">-->
    <!--        <h5>-->
    <!--          <i class="dot"></i> 점검대상-->
    <!--        </h5>-->
    <!--      </vs-col>-->
    <!--    </vs-row>-->

    <!--    <div class="gap-x-6 gap-y-4 mt-4">-->
    <!--      <span v-if="isPrint"> {{form.inspectionTitle}} </span>-->
    <!--      <div class="ml-group-checkBox flex flex-wrap w-full flex-1" v-else>-->
    <!--        <vs-checkbox-->
    <!--          class="mr-1 mb-2"-->
    <!--          :readonly="board.readonly">-->
    <!--          {{form.inspectionTitle}}-->
    <!--        </vs-checkbox>-->
    <!--      </div>-->
    <!--    </div>-->

    <!--    고소작업대-->
    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="form.inspectionTitle"
      :list="form.inspectList"
      @update-list-check="updateListCheck"
    />

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :is-print="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :is-print="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader.vue";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        this.form.inspectionTitle = this.inspectionTitle;
        if (
          !this.form ||
          !this.form.inspectList ||
          this.form.inspectList.length === 0
        ) {
          this.form.inspectList = this.inspectTable;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle: "고소작업대",
      form: {
        inspectionTitle: "고소작업대",
        stdInfo: {},
        photoList: [],
        fileList: [],
        equipmentList: [],
        inspectList: [],
      },
    };
  },
  computed: {
    inspectTable() {
      return [
        {
          id: 1,
          label:
            "고소작업대에 대한 작업계획서*를 작성하고 이행한다.\n" +
            "       *추락·낙하·전도·협착·붕괴 위험대책, 운행경로 및 작업방법",
          is_checked: "",
          title: "공통",
        },
        {
          id: 2,
          label:
            "작업지휘자 또는 유도자를 배치하여 작업계획서에 따라 작업을 지휘하여야 한다.",
          is_checked: "",
          title: "공통",
        },
        {
          id: 3,
          label:
            "작업대에 탑승하는 작업자는 안전모 및 안전대를 착용하여야 한다.",
          is_checked: "",
          title: "공통",
        },
        {
          id: 4,
          label: "작업대에 정격하중을 초과하여 물건을 싣거나 탑승하지 않는다.",
          is_checked: "",
          title: "공통",
        },
        {
          id: 5,
          label: "작업구간에 관계 작업자가 아닌 사람의 출입을 금지한다.",
          is_checked: "",
          title: "공통",
        },
        {
          id: 6,
          label:
            "조종사의 적정 자격을 확인한다.\n" +
            "      *기중기운전기능사 또는 교육 이수",
          is_checked: "",
          title: "차량탑재형",
        },
        {
          id: 7,
          label: "안전인증 및 안전검사 실시 여부를 확인한다.",
          is_checked: "",
          title: "차량탑재형",
        },
        {
          id: 8,
          label:
            "아웃트리거 및 브레이크 등을 확실히 사용하며 아웃트리거는 지면과 수평을 유지하도록 설치한다.",
          is_checked: "",
          title: "차량탑재형",
        },
        {
          id: 9,
          label:
            "붐 길이와 각도에 적합한 적재하중 및 허용 작업반경을 확인한다.",
          is_checked: "",
          title: "차량탑재형",
        },
        {
          id: 10,
          label: "안전인증 표시가 부착되어 있는지 확인한다.",
          is_checked: "",
          title: "시저형",
        },
        {
          id: 11,
          label: "작업대 안전난간의 파손 및 탈락여부를 확인한다.",
          is_checked: "",
          title: "시저형",
        },
        {
          id: 12,
          label: "고소작업대는 항상 바닥과 수평을 유지하도록 한다.",
          is_checked: "",
          title: "시저형",
        },
        {
          id: 13,
          label: "작업대에 과상승방지장치를 설치하고 작동유무를 확인한다.",
          is_checked: "",
          title: "시저형",
        },
        {
          id: 14,
          label: "작업대를 올린 상태에서 작업자를 태우고 이동하지 않는다.",
          is_checked: "",
          title: "시저형",
        },
      ];
    },
  },
  methods: {
    updateList(list) {
      this.form.equipmentList = list;
    },
    updateListCheck(indexRows, text) {
      this.form.inspectList[indexRows].is_checked = text;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
